// removed by extract-text-webpack-plugin
module.exports = {"easyHeading":"styles__easyHeading__2io-q","howItWorks":"styles__howItWorks__27x07","list":"styles__list__NAQBS","image":"styles__image__bEzKG","description":"styles__description__3d65O"};


//////////////////
// WEBPACK FOOTER
// ./src/components/OtherOptions/styles.scss
// module id = 400
// module chunks = 0